import { render, staticRenderFns } from "./HallOfFameForex.vue?vue&type=template&id=56c7583d&scoped=true"
import script from "./HallOfFameForex.vue?vue&type=script&lang=js"
export * from "./HallOfFameForex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7583d",
  null
  
)

export default component.exports